<template>
  <!-- <v-alert text="info コンポーネント サンプル" type="info"></v-alert> -->
  <router-view/>
</template>
<script>
import axios from 'axios'
// import { common } from './components/common.js'
// import router from './router'
// import myFunction from './components/commonFnc.js'
export default {
  // mixins: [common],
  data () {
    return {
      scrollY: 0,
      result: '',
      arguseridx: ''
    }
  },
  mounted () {
    /*
    this.$router.beforeEach((to, from, next) => {
      window.alert('to ' + to.path)
      window.alert('from ' + from.path)
      window.alert('beforeEach')
      // this.$router.push(window.currentId)
    })
      */
    /*
    window.addEventListener('popstate', function () {
      this.$router.replace(window.currentId)
    })
      */
  },
  methods: {
    start1 () {
      window.alert('start')
      window.alert(this.userId)
      window.alert('count ' + window.count)// eslint-disable-line
      window.initFnc()
      window.alert('count ' + window.count)// eslint-disable-line
      // this.initFnc2()
      window.alert(window.leftx)// eslint-disable-line
      axios.post('/api/login', { arguserid: this.userId })
        .then(response => {
          this.results = response.data
          if (this.results.result === 'NG') {
            alert(this.results.resultErrMsg)
          } else {
            alert(JSON.stringify(this.results))
          }
        })
        .catch(error => {
          alert('kudo ' + error)
        })
    }
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

html, body {
  min-width: 1200px !important;
  overflow-x: auto !important;
}

#app {
  min-width: 1200px !important;
}

#app-wrapper {
  min-width: 1200px !important;
  overflow-x: auto !important;
}

/* Vuetify の main 部分を縮ませない */
.v-application__wrap {
  min-width: 1200px !important;
}

v-main {
  min-width: 1200px !important;
}

/* container を縮ませない（ここが犯人かな） */
.v-container {
  min-width: 1200px !important;
}

</style>
